import React from 'react';

//Utils
import { MESSAGES } from '~/utils/message';
import OlcButton from '~/components/General/OlcButton';

//MUI Component
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Icons
import { ExportContacts2CIcon, DetailsCrossCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ExportModal = (props) => {
  const { handleClose, open, handleExport, message, header, subject, loading } = props;

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="contactExportModal"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 15,
            top: 15,
            padding: '0',
            color: (theme) => theme.palette.grey[500],
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <img src={DetailsCrossCIcon} alt="close" />
        </IconButton>
        <DialogContent className="exportModalContent" dividers>
          <Box className="exportModalIcon">
            <img src={ExportContacts2CIcon} alt="export" />
          </Box>
          <Box className="exportHeader">
            <Typography gutterBottom variant="h4">
              {header}
            </Typography>
            <Typography gutterBottom>{message}</Typography>
            <Typography className="confirm" gutterBottom variant="p">
              {subject}
            </Typography>
          </Box>
          <Box className="exportModalBtns">
            <OlcButton variant="secondary" onClick={handleClose}>
              {MESSAGES.CONTACTS.DELETE.CANCEL_BUTTON}
            </OlcButton>
            <OlcButton variant="primary" onClick={handleExport} disabled={loading}>
              {loading ? (
                <CircularProgress
                  sx={{
                    color: 'white',
                    width: '25px !important',
                    height: '25px !important',
                  }}
                />
              ) : (
                MESSAGES.CONTACTS.DELETE.SUBMIT_BUTTON
              )}
            </OlcButton>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default ExportModal;
